import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
const FaqECommerce = () => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleItem = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleAll = () => {
    if (openIndexes.length === faqData.length) {
      setOpenIndexes([]);
    } else {
      setOpenIndexes(faqData.map((_, i) => i));
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const faqData = [
    {
      question: "What is an e-commerce platform? ",
      answer:
        "An e-commerce platform includes websites and mobile application that allows businesses to buy and sell products or services online. It typically includes features for managing inventory, processing payments, handling customer accounts, and facilitating communication between buyers and sellers.",
    },
    {
      question:
        "Is there any difference between an e-commerce website and an e-commerce app?",
      answer:
        "Yes, an e-commerce website is accessed through a browser, while an e-commerce app is a software application designed specifically for mobile devices (iOS/Android), offering features optimized for mobile shopping experiences",
    },
    {
      question:
        "Why should I choose Deetya soft for an e-commerce platform for my business?",
      answer:
        "We, at Deetya soft have a team of experts who will assist you in providing an e-commerce platform as per your business requirements, which helps ultimately in streamline the selling process, expand your reach to a global audience, provide better customer experience, automate tasks like payment processing, and support various marketing and customer engagement strategies.",
    },
    {
      question: "What are the key features of an e-commerce platform?",
      answer:
        "Key features of an e-commerce platform include product catalogue, shopping cart, payment gateway, order management, customer accounts, inventory management, product search, secure payment options, and customer support.",
    },
    {
      question: "How can I ensure the security of my e-commerce platform?",
      answer:
        "Ensure data encryption (SSL), use secure payment gateways, adhere to PCI DSS standards, implement two-factor authentication, and regularly update security protocols to protect user data and transactions.",
    },
    {
      question: "How can I integrate social media with my e-commerce platform?",
      answer:
        "Yes, off course you can, social media integration allows your customers to share products, reviews, or their shopping experiences directly to platforms like Instagram, Facebook, or Twitter. It also supports social login features for easier user registration.",
    },
    {
      question: "How can I optimize my e-commerce app for mobile devices?",
      answer:
        "Ensure your app is mobile-responsive, loads quickly, has an intuitive interface, and integrates mobile payment systems. Additionally, optimize images and reduce unnecessary features to improve performance.",
    },
  ];

  return (
    <div className="bg-white py-8">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
          <div className="w-full text-center md:pb-10">
            <h2 className="text-xl md:text-3xl font-semibold text-main">
              Frequently Asked Questions (Faq)
            </h2>
            <div className="border-b-4 border-main w-20 md:w-40 mx-auto my-2 rounded-full" />
          </div>

          <button
            onClick={toggleAll}
            className="text-sm font-medium text-black underline hover:text-blue-700 whitespace-nowrap sm:self-end"
          >
            {openIndexes.length === faqData.length
              ? "Collapse all"
              : "Expand all"}
          </button>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-xl shadow-sm overflow-hidden"
              data-aos="fade-up"
            >
              <button
                onClick={() => toggleItem(index)}
                className="w-full bg-primaryPri flex justify-between items-center px-6 py-4 text-left"
              >
                <p className="md:text-lg text-sm font-medium text-black">
                  {item.question}
                </p>

                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`w-3 h-3 transform transition-transform ${
                    openIndexes.includes(index) ? "rotate-180" : ""
                  }`}
                />
              </button>

              {openIndexes.includes(index) && (
                <div
                  className="px-6 pb-4 text-gray-700 text-xs md:text-sm"
                  data-aos="fade-down"
                >
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqECommerce;
